import { pawnshop_reports_reader_service } from "../../../api/restclient";
import { formatDateParam } from "../lib/makeRequest";

const transformResponse = (params, response) => ({
  key: params,
  value: JSON.parse(response),
});

export const makeRequest = async (endpoint, params, method = "get") => {
  try {
    const response =
      method === "get"
        ? await pawnshop_reports_reader_service.get(endpoint, params, {
            transformResponse: (resp) => transformResponse(params, resp),
          })
        : await pawnshop_reports_reader_service.post(endpoint, params, {
            transformResponse: (resp) => transformResponse(params, resp),
          });
    return response;
  } catch {
    return Promise.resolve();
  }
};

const createParams = (data) => {
  return {
    current_month: data.current_month,
    current_year: data.current_year,
    previous_month: data.previous_month,
    previous_year: data.previous_year,
  };
};

const constructArrayParams = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("current_month", data.current_month);
  arrayParams.append("current_year", data.current_year);
  arrayParams.append("previous_month", data.previous_month);
  arrayParams.append("previous_year", data.previous_year);
  return arrayParams;
};

const constructCoveredParams = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("covered_date", data.covered_date);
  return arrayParams;
};

export const average_overall = (data) => {
  return makeRequest("/sales/average/overall", createParams(data));
};

export const average_by_cluster = (data) => {
  return makeRequest(
    `/sales/average/cluster/${data.clusterId}`,
    createParams(data)
  );
};

export const average_by_area = (data) =>
  makeRequest(`/sales/average/area/${data.areaId}`, createParams(data));

export const average_by_branch = (data) =>
  makeRequest(
    `/sales/average/branches?${constructArrayParams(data)}`,
    data.branch_codes,
    "post"
  );

export const active_overall = (data) =>
  makeRequest("/sales/active/overall", {
    covered_date: formatDateParam(data.covered_date),
  });

export const active_by_cluster = (data) =>
  makeRequest(`/sales/active/cluster/${data.clusterId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const active_by_area = (data) =>
  makeRequest(`/sales/active/area/${data.areaId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const active_by_branch = (data) =>
  makeRequest(
    `/sales/active/branches?${constructCoveredParams(data)}`,
    data.branch_codes,
    "post"
  );

export const expired_overall = (data) =>
  makeRequest("/sales/expired/overall", {
    covered_date: formatDateParam(data.covered_date),
  });

export const expired_by_cluster = (data) =>
  makeRequest(`/sales/expired/cluster/${data.clusterId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const expired_by_area = (data) =>
  makeRequest(`/sales/expired/area/${data.areaId}`, {
    covered_date: formatDateParam(data.covered_date),
  });

export const expired_by_branch = (data) =>
  makeRequest(
    `/sales/expired/branches?${constructCoveredParams(data)}`,
    data.branch_codes,
    "post"
  );
